import React, { memo, useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';

import { PlusOutlined } from '@ant-design/icons';
import { Button, Row } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import whitelistService from 'v2/services/whitelist';

import CreateAndEdit from './CreateAndEdit';
import Filter from './Filter';
import List from './List';

const WhiteList = () => {
  useEffect(() => {
    whitelistService.loadWhiteLists().subscribe(() => {}, toast.error);
  }, []);

  const newWhiteList = useCallback(() => {
    whitelistService.setCurrentWhiteList(null);
    whitelistService.setCreateAndEditDialog(true);
  }, []);

  useEffect(() => {
    return () => whitelistService.cleanFilter();
  }, []);

  return (
    <>
      <Row justify='space-between' align='top' className='mb-4'>
        <div className='text-text-heading flex w-full flex-1 flex-col max-sm:flex-none [&_h1]:mb-2! [&_h1]:text-3xl! [&_h1]:leading-none! [&_h1]:font-normal! [&_p]:text-base! [&_p]:leading-5.25! [&_p]:text-[#818b9d]!'>
          <h1>Recompra (Whitelist)</h1>
          <p>Gerencie clientes que podem comprar várias vezes com o mesmo CPF/CNPJ.</p>
        </div>
        <PermissionHide action='myeduzz:whitelist:editar'>
          <div className='max-sm:mt-4 max-sm:w-full'>
            <Button type='primary' icon={<PlusOutlined />} onClick={newWhiteList} block>
              Adicionar cliente
            </Button>
          </div>
        </PermissionHide>
      </Row>
      <CreateAndEdit />
      <Filter />
      <List />
    </>
  );
};

export default memo(WhiteList);
